import * as React from 'react';

import { useModalContext } from 'common/contexts';
import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';
import EventProcedureStep from 'security-app/components/SecurityEvents/EventProcedures/plugin/EventProcedureStepForm';

import EventProcedureModal from './EventProcedureModal';
import EventProcedureDetailsDrawer from './DetailsDrawer';

export type ModalTypes =
  | 'CREATE-EVENT-PROCEDURE'
  | 'EDIT-EVENT-PROCEDURE'
  | 'CREATE-EVENT-PROCEDURE-STEP'
  | 'EDIT-EVENT-PROCEDURE-STEP'
  | 'SHOW-EVENT-PROCEDURE-DETAILS';

function EventProceduresModals() {
  const { modal, setModal, entity, setEntity } = useModalContext();

  const onClose = () => {
    setModal(null);
    setEntity(null);
  };

  switch (modal) {
    case 'CREATE-EVENT-PROCEDURE':
      return <EventProcedureModal onClose={onClose} isCreate />;
    case 'EDIT-EVENT-PROCEDURE':
      return <EventProcedureModal onClose={onClose} eventProcedureId={entity as string} />;
    case 'CREATE-EVENT-PROCEDURE-STEP':
      return <EventProcedureStep onClose={onClose} />;
    case 'EDIT-EVENT-PROCEDURE-STEP':
      return <EventProcedureStep eventProcedureStep={entity as EventProcedureStepAPIType} onClose={onClose} />;
    case 'SHOW-EVENT-PROCEDURE-DETAILS':
      return (
        <EventProcedureDetailsDrawer
          eventProcedure={entity as EventProceduresAPIType<Array<EventProcedureStepAPIType>>}
          onClose={onClose}
        />
      );
    default:
      return null;
  }
}

export default EventProceduresModals;
